import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { graphingColors, mdScreen } from '../../lib/constants';
import { FlipToFront } from '@material-ui/icons';
import { DashboardLayout } from './DashboardLayout';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { Switch } from '../../components/Switch';
import { Tooltip } from '../../components/Tooltip';

export const Dashboard = () => {
  const [lock, setLock] = useState(true);
  const isMobile = useMediaQuery(mdScreen);

  useEffect(() => {
    if (isMobile) setLock(true);
  }, [isMobile]);

  const handleLock = (e: any) => {
    setLock(e.target.checked);
  };

  return (
    <>
      <div className="flex flex-row items-center justify-start gap-[12]">
        <div
          className={clsx({ hidden: isMobile, 'flex ml-[25px]': !isMobile })}
        >
          <FlipToFront
            style={{
              padding: 3,
              color: `${lock ? '#d1d1d1' : '#404040'}`,
            }}
            fontSize="large"
          />
          <Tooltip title={lock ? 'Unlock layout' : 'Lock layout'} showArrow>
            <Switch
              name="lock"
              checked={lock}
              color="primary"
              onChange={handleLock}
            />
          </Tooltip>
        </div>
      </div>

      <DashboardLayout lockLayout={lock} theme={graphingColors[0].colors} />
    </>
  );
};
